import busy from './busyReducer';
import user from './userReducer';
import book from './bookReducer';

export default {
  busy,
  user,
  book,
};
